import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const VisibilityHidden = (props) => (
  <Icon viewBox="0 0 17 15" {...props}>
    <g>
      <title>Fill 1</title>
      <path d="M13.031 11.031l-2.044-2.044a3.187 3.187 0 0 0 .498-1.714c0-1.714-1.339-3.109-2.985-3.109-.651 0-1.25.225-1.741.595L4.864 2.864A6.791 6.791 0 0 1 8.5 1.809c4.569 0 6.934 4.454 7.411 5.464-.28.597-1.221 2.387-2.88 3.758zM7.495 5.495A1.903 1.903 0 0 1 8.5 5.2c1.098 0 1.99.93 1.99 2.073 0 .354-.093.682-.244.973L7.495 5.495zm2.321 3.321a1.933 1.933 0 0 1-1.316.529c-1.097 0-1.99-.929-1.99-2.072 0-.497.176-.948.457-1.306l2.849 2.849zM8.5 12.737c-4.568 0-6.933-4.454-7.41-5.465.297-.632 1.329-2.609 3.18-4.002l1.981 1.981a3.157 3.157 0 0 0-.736 2.022c0 1.714 1.339 3.109 2.985 3.109.788 0 1.501-.326 2.035-.847l1.926 1.926c-1.066.739-2.377 1.276-3.961 1.276zM17 7.273l-.082-.202C16.814 6.814 14.294.773 8.5.773c-1.756 0-3.208.559-4.386 1.341L2 0l-.5.5 2.035 2.035C1.229 4.34.15 6.905.082 7.071L0 7.273l.082.202c.105.257 2.625 6.298 8.418 6.298 1.921 0 3.475-.669 4.707-1.566L15.5 14.5l.5-.5-2.231-2.231c2.099-1.784 3.085-4.136 3.149-4.294L17 7.273z"
        fill="currentColor" fillRule="evenodd" />
    </g>
  </Icon>
);
/*eslint-enable */

export default VisibilityHidden;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/VisibilityHidden.js